<template>
  <div>
    <dl-form
      ref='refForm'
      labelWidth="90px"
      :formAttributeArr="formAttributeArr"
    >
      <template v-slot:formItem>
        <el-button
          class="w100 wrap"
          type="primary"
          round
          @click="handleNext"
        >下一步</el-button>
      </template>
    </dl-form>

  </div>
</template>

<script>
import { CaptchaCode, SendPhoneCode } from '@/components'
export default {
  components: {
    CaptchaCode,
  },
  props: {
    currentStep: Number,
  },
  data () {
    return {
      formAttributeArr: [
        {
          type: 'input',
          keyName: 'phone',
          formItem: {
            label: '手机号',
            rules: {required: true}
          },
        },
        {
          type: 'input',
          keyName: 'captcha_code',
          formItem: {
            label: '验证码',
            rules: {required: true}
          },
          component: CaptchaCode
        },
        {
          type: 'input',
          keyName: 'verify_code',
          formItem: {
            label: '短信验证',
            rules: {required: true}
          },
          compAttrs: {
            ensure_user_exists: true,
          },
          component: SendPhoneCode
        },
      ]
    }
  },
  computed: {},
  methods: {
    handleNext() {
      const { data } = this.$refs.refForm.validate()
      if (data) {
        this.$emit('goNext', data)
      }
    },
  }
}
</script>
<style lang='scss' scoped>
</style>